<template>
  <div class="cms-content cms-style" v-loading.fullscreen="loading" v-html="cmsHtml"></div>
</template>

<script>

  export default {
    props: ['type'],
    data: function () {
      return {
        cmsHtml: '',
        loading: true
      }
    },
    methods: {
      getCms() {
        document.getElementById('app').classList.add('cms-page')
        this.axios.get('/api/employee/info/term', {
          params: {
            type: this.type,
            lang: this.$i18n.locale || 'tc'
          }
        }).then((res) => {
          if (res.code === 200) {
            this.cmsHtml = res.data.content;
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    created() {
      this.getCms()
    }
  }

</script>
